import PropTypes from 'prop-types';
import React, {Component} from 'react';
import classNames from 'classnames';
import Loader from 'components/loader';
import {FormattedMessage} from 'react-intl';
import {makeCancelable} from 'helpers/cancelablePromise';

class _DashboardTile extends Component {
  static propTypes = {
    onUpdate: PropTypes.func,
    onActiveChange: PropTypes.func,
    title: PropTypes.string,
    id: PropTypes.number,
    activeReport: PropTypes.number,
    start: PropTypes.object,
    end: PropTypes.object,
    formatter: PropTypes.any,
    branch: PropTypes.any,
    branches: PropTypes.any,
    dontUpdateOnFilter: PropTypes.bool,
    POS: PropTypes.bool,
    onlyPOS: PropTypes.bool,
    dashOnZero: PropTypes.bool,
    onError: PropTypes.func.isRequired,
  };

  static defaultProps = {
    dontUpdateOnFilter: false,
    formatter: false,
    onlyPOS: false,
    POS: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: null,
      loading: true,
    };
  }

  componentWillMount() {
    this.getValue();
  }

  shouldComponentUpdate(nextProps) {
    // Don't update tile if just switching between active reports
    return !(nextProps.activeReport !== this.props.activeReport &&
      nextProps.activeReport !== nextProps.id && this.props.activeReport !== this.props.id &&
      nextProps.start === this.props.start && nextProps.end === this.props.end && nextProps.branches === this.props.branches &&
      nextProps.branch === this.props.branch);
  }

  componentDidUpdate(prevProps) {
    const {dontUpdateOnFilter, start, branch} = this.props;

    if (!dontUpdateOnFilter && prevProps.start !== start) {
      this.getValue();
    } else if (prevProps.branch !== branch) {
      this.getValue();
    }
  }

  componentWillUnmount() {
    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }
  }

  getValue() {
    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }

    const {onUpdate, start, end, POS, onlyPOS, dashOnZero} = this.props;

    this.setState({
      loading: true,
    });

    if (onlyPOS && !POS) {
      return 'Not Available';
    }

    // Make promises cancelable so switching date ranges quickly doesn't override data
    return (this.fetching = makeCancelable(onUpdate(start, end)))
      .then(data => {
        if (!this.shouldTileUpdate({start, end})) {
          console.log('Blocking update since time frame changed.');
          return;
        }

        if (dashOnZero && (!data || data === 0) || !data && data !== 0) {
          data = '-';
        }

        this.setState({
          value: data,
          loading: false,
        });
      })
      .catch(e => {
        if (e && e.canceled) {return;}

        this.props.onError(e);
      });
  }

  shouldTileUpdate = ({start, end}) => {
    return start === this.props.start && end === this.props.end;
  };

  render() {
    const {onActiveChange, activeReport, id, title, formatter, POS} = this.props;

    return <div className={classNames('grid-data', {
      'col-sm-4': !POS,
      'col-sm-3': !!POS,
      active: activeReport === id,
    })}
           onClick={() => onActiveChange(id)}>
      <p>{title}</p>
      {/* Spacing fix for when loading */}
      {this.state.loading ? <div className='data'>&nbsp;</div> : null}
      <Loader loaded={!this.state.loading}>
        {formatter && ((this.state.value || this.state.value === 0) && this.state.value !== '-') ?
          <div className='data'>{formatter(this.state.value)}</div> :
          <div className='data'>{this.state.value}</div>}
      </Loader>
    </div>;
  }
}

// Add error state if component catches
class DashboardTile extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    POS: PropTypes.bool,
    id: PropTypes.number,
    onlyPOS: PropTypes.bool,
    activeReport: PropTypes.number,
    start: PropTypes.object,
    end: PropTypes.object,
    branches: PropTypes.any,
    branch: PropTypes.any,
  };

  state = {
    error: false,
  };

  componentWillReceiveProps(nextProps) {
    // Reset error state on date range change
    if (nextProps.start !== this.props.start || nextProps.end !== this.props.end || nextProps.branches !== this.props.branches ||
      nextProps.branch !== this.props.branch) {
      this.setState({error: false});
    }
  }

  componentDidCatch(err) {
    return this.onError(err);
  }

  onError = (err) => {
    this.setState({error: true});

    console.error(err);
  };

  render() {
    if (this.props.onlyPOS && !this.props.POS) {
      return null;
    }

    if (this.state.error) {
      return <div className={classNames('grid-data', {
        'col-sm-4': !this.props.POS,
        'col-sm-3': this.props.POS,
        active: this.props.activeReport === this.props.id,
      })}>
        <p>{this.props.title}</p>
        <p className='data'><FormattedMessage id='general.error'>{err => err.toUpperCase()}</FormattedMessage></p>
      </div>;
    }

    return <_DashboardTile {...this.props} onError={this.onError} />;
  }
}

export default DashboardTile;
